/*
* Created on Jan 11, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React, {useEffect, useState} from 'react';
import welcome_illu_svg from '../../static/img/organization/welcome-illustration.svg'
import {useTranslation} from "react-i18next";
import OrganizationWizardComponent from "./Organization/OrganizationWizardComponent";

const MainWelcomeComponent = ({doRefresh}) => {
    const {t} = useTranslation();
    const [openWizard, setOpenWizard] = useState(false);
    return (
        <div className="content content-page">
            <article className="welcome-screen">
                <div className="welcome-title">{t('@Organization@')}</div>
                <div className="welcome-desc">{t('@Welcome to use organization function. If you are IT administrators or MSP, you can create a organization to use the function of equipments centralized management.@')}</div>
                <div className="welcome-illustration"><img src={welcome_illu_svg} /></div>
                <button type="button" className="q-btn q-btn-primary q-btn-large" onClick={()=>setOpenWizard(true)}>{t('@Create my first organization now!@')}</button>
            </article>
            {openWizard && <OrganizationWizardComponent openModal={openWizard} closeModal={()=>setOpenWizard(false)} doRefresh={doRefresh}/>}
        </div>
    );
};

export default MainWelcomeComponent;